import ThankYouIcon from '@/assets/icons/ThankYouIcon';
import ThankYouPageCalendarIcon from '@/assets/icons/ThankYouPageCalendarIcon';
import { useGetOrganizations } from '@/apis/agency/organizations/hook';
import { Box, Typography, Paper, Button } from '@mui/material';

export default function OnboardingThankYou() {
  const { data: organizationData } = useGetOrganizations();
  const supportCalendar = organizationData?.configuration?.support_calendar?.trim();

  const handleScheduleMeeting = () => {
    if (supportCalendar) {
      window.open(supportCalendar, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      minHeight='calc(100vh - 88px)' // subtract onboarding header height
    >
      <Paper
        elevation={0}
        sx={{
          borderRadius: 4,
          boxShadow: '0px 10px 30px rgba(0,0,0,0.08)',
          p: { xs: 3, lg: 4 },
          m: 3,
          maxWidth: 520,
          textAlign: 'center'
        }}
      >
        <Box display='flex' flexDirection='column' alignItems='center' gap={2}>
          <ThankYouIcon />

          <Typography fontSize={24} fontWeight={500} color='#111'>
            Thank You!
          </Typography>

          <Typography fontSize={14} color='#6B6B6B' maxWidth={420}>
            We have received your business details. Our team will start getting your agent ready.
          </Typography>

          <Box
            sx={{
              mt: 1,
              px: 2,
              py: 1.5,
              borderRadius: 2,
              border: '1px solid #EFEFEF',
              backgroundColor: '#FAFAFA',
              maxWidth: 460
            }}
          >
            <Typography fontSize={14} color='#6B6B6B'>
              This typically takes up to 2 weeks. Your Account Manager will update you once your agent is ready.
            </Typography>
          </Box>

          {supportCalendar && (
            <Button
              variant='contained'
              fullWidth
              onClick={handleScheduleMeeting}
              startIcon={<ThankYouPageCalendarIcon />}
              sx={{
                mt: 1,
                borderRadius: 20,
                textTransform: 'none',
                py: 1.5,
                fontSize: 14,
                fontWeight: 500,
                maxWidth: 460
              }}
            >
              Schedule a meeting with our Onboarding Team
            </Button>
          )}
        </Box>
      </Paper>
    </Box>
  );
}
